import React from "react";
import AppMenuitem from "./AppMenuitem";
import { MenuProvider } from "./context/menucontext";
import { AppMenuItem } from "../types/types";
import { useAuth } from "../utils/auth";
import { Role } from "../services/auth/auth.dto";

const AppMenu = () => {
  const auth = useAuth();
  const role = auth.getUser().role;
  const isAdmin = role === Role.ADMIN;
  const isCommunityUser = role === Role.OSBUK_USER || isAdmin;

  const model: AppMenuItem[] = [
    {
      label: "Genel",
      items: [
        { label: "Ana Sayfa", icon: "pi pi-fw pi-home", to: "/app/homepage" }
      ]
    },
    {
      label: "Anketler",
      items: [
        {
          label: "Anketler",
          icon: "pi pi-fw pi-list-check",
          to: "/app/anketler"
        },
        {
          label: "Stratejik Anket",
          icon: "pi pi-fw pi-clipboard",
          to: "/app/stratejik-anket"
        },
        {
          label: "Çevresel Göstergeler",
          icon: "pi pi-fw pi-globe",
          to: "/app/cevresel-gostergeler-anket"
        }
      ]
    },
    {
      label: "Araçlar",
      items: [
        {
          label: "Hesaplama",
          icon: "pi pi-fw pi-calculator",
          to: "/app/karbonayakizi"
        },
        {
          label: "Raporlama",
          icon: "pi pi-fw pi-file-pdf",
          to: "/app/rapor"
        },
        {
          label: "Analiz",
          icon: "pi pi-fw pi-chart-line",
          to: "/app/grafik"
        },
        {
          label: "Eğitim",
          icon: "pi pi-fw pi-book",
          to: "/app/egitim"
        },
        {
          label: "İş Sürekliliği Planı",
          icon: "pi pi-fw pi-shield",
          to: "/app/is-surekliligi"
        },
        {
          label: "OSBÜK Bülten",
          icon: "pi pi-fw pi-envelope",
          to: "/app/bulten"
        },
        {
          label: "Başkan Mesajı",
          icon: "pi pi-fw pi-user",
          to: "/app/baskan-mesaj"
        }
      ]
    },
    {
      label: "Topluluk",
      visible: isCommunityUser,
      items: [
        {
          label: "Forum",
          icon: "pi pi-fw pi-comments",
          to: "/app/forum-homepage",
          visible: isCommunityUser
        },
        {
          label: "Stratejik Plan Çalışması",
          icon: "pi pi-fw pi-compass",
          to: "/app/stratejik-plan",
          visible: isCommunityUser
        },
        {
          label: "Yapay Zeka Sohbeti",
          icon: "pi pi-fw pi-comment",
          to: "/app/yapay-zeka",
          visible: isCommunityUser
        }
      ]
    },
    {
      label: "Yönetim",
      visible: isAdmin,
      items: [
        {
          label: "Anket Yönetimi",
          icon: "pi pi-fw pi-list-check",
          to: "/admin/dinamik-anket-yonetim"
        },
        {
          label: "Stratejik Anket Raporu",
          icon: "pi pi-fw pi-chart-pie",
          to: "/admin/stratejik-rapor"
        },
        {
          label: "Çevresel Göstergeler Raporu",
          icon: "pi pi-fw pi-chart-line",
          to: "/admin/cevresel-gostergeler-rapor"
        },
        {
          label: "Belgeler",
          icon: "pi pi-fw pi-folder",
          to: "/admin/belgeler"
        },
        {
          label: "Kullanıcılar",
          icon: "pi pi-fw pi-users",
          to: "/admin/users"
        },
        {
          label: "Toplu E-posta",
          icon: "pi pi-fw pi-send",
          to: "/admin/send-mass-email"
        },
        {
          label: "Sayfa İçerikleri",
          icon: "pi pi-fw pi-pencil",
          to: "/admin/page-edit"
        }
      ]
    }
  ];

  return (
    <MenuProvider>
      <ul className="layout-menu">
        {model.map((item, i) =>
          !item?.seperator ? (
            <AppMenuitem item={item} root={true} index={i} key={item.label} />
          ) : (
            <li key={i} className="menu-separator"></li>
          )
        )}
      </ul>
    </MenuProvider>
  );
};

export default AppMenu;
